require('../../modules/es6.object.get-prototype-of');
module.exports = require('../../modules/_core').Object.getPrototypeOf;


//////////////////
// WEBPACK FOOTER
// /app/node_modules/core-js/library/fn/object/get-prototype-of.js
// module id = 821
// module chunks = 0